module.exports = __webpack_public_path__ + "img/sigap-logo.4719195a.png";